import { render, staticRenderFns } from "./SupportMaterials.vue?vue&type=template&id=03a6b879&"
import script from "./SupportMaterials.vue?vue&type=script&lang=js&"
export * from "./SupportMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports